<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div
    role="tablist"
    class="flex items-center gap-1 p-1 mx-3 mb-1 rounded-xl bg-n-background"
  >
    <button
      v-for="(item, index) in items"
      :key="item.key"
      type="button"
      role="tab"
      :aria-selected="item.key === activeTab"
      class="flex items-center justify-center flex-1 min-w-0 gap-1.5 h-7 px-2 text-xs font-medium transition-colors rounded-lg"
      :class="
        item.key === activeTab
          ? 'bg-n-violet-3 text-n-violet-11'
          : 'text-n-slate-11 hover:text-n-slate-12 hover:bg-n-alpha-1'
      "
      @click="onTabChange(index)"
    >
      <span class="truncate">{{ item.name }}</span>
      <span
        class="px-1 rounded-full text-xxs leading-4 shrink-0"
        :class="
          item.key === activeTab
            ? 'bg-n-violet-4 text-n-violet-11'
            : 'bg-n-alpha-2 text-n-slate-10'
        "
      >
        {{ item.count }}
      </span>
    </button>
  </div>
</template>
